__turbopack_context__.v({
  "acceptBtn": "CProcedures-module__94RS5G__acceptBtn",
  "actionBtn": "CProcedures-module__94RS5G__actionBtn",
  "actionIcon": "CProcedures-module__94RS5G__actionIcon",
  "detail": "CProcedures-module__94RS5G__detail",
  "detailActions": "CProcedures-module__94RS5G__detailActions",
  "detailBody": "CProcedures-module__94RS5G__detailBody",
  "detailClose": "CProcedures-module__94RS5G__detailClose",
  "detailHeader": "CProcedures-module__94RS5G__detailHeader",
  "detailParent": "CProcedures-module__94RS5G__detailParent",
  "detailTitle": "CProcedures-module__94RS5G__detailTitle",
  "docName": "CProcedures-module__94RS5G__docName",
  "fileBtn": "CProcedures-module__94RS5G__fileBtn",
  "note": "CProcedures-module__94RS5G__note",
  "pageButton": "CProcedures-module__94RS5G__pageButton",
  "pageInfo": "CProcedures-module__94RS5G__pageInfo",
  "pagination": "CProcedures-module__94RS5G__pagination",
  "rejectBtn": "CProcedures-module__94RS5G__rejectBtn",
  "root": "CProcedures-module__94RS5G__root",
  "searchWrap": "CProcedures-module__94RS5G__searchWrap",
  "sortIcon": "CProcedures-module__94RS5G__sortIcon",
  "sortIconActive": "CProcedures-module__94RS5G__sortIconActive",
  "table": "CProcedures-module__94RS5G__table",
  "tableWrap": "CProcedures-module__94RS5G__tableWrap",
  "thInner": "CProcedures-module__94RS5G__thInner",
  "thSortable": "CProcedures-module__94RS5G__thSortable",
  "toolbar": "CProcedures-module__94RS5G__toolbar",
  "truncatedHint": "CProcedures-module__94RS5G__truncatedHint",
});
